import React, { useState, useEffect } from 'react';
import API from '../utils/axios';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FileText } from 'lucide-react';

const DEFAULT_CONTENT = `Dengan menggunakan platform ini, Anda setuju untuk mematuhi syarat dan ketentuan yang berlaku.

Setiap kombinasi Website + User ID hanya dapat membuat 1 prediksi per pertandingan. Prediksi ditutup otomatis saat pertandingan dimulai dan tidak dapat diubah setelah dikirim.

Pemenang akan ditentukan berdasarkan hasil validasi admin. Hadiah akan diberikan sesuai dengan ketentuan yang berlaku.

Kami berhak mengubah syarat dan ketentuan ini kapan saja tanpa pemberitahuan sebelumnya.`;

export const Terms = () => {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await API.get('/settings');
        if (data?.terms_content && data.terms_content.trim()) {
          setContent(data.terms_content);
        }
      } catch (e) {
        // fallback to default
      }
    })();
  }, []);

  return (
    <div className="App">
      <Header />

      <section className="py-24 container mx-auto px-4 min-h-screen">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <FileText className="inline-block text-[#FFD60A] mb-4" size={64} />
            <h1 className="text-4xl md:text-5xl font-black text-white mb-4 tracking-tight" data-testid="terms-title">
              Syarat &amp; Ketentuan
            </h1>
          </div>

          <div
            className="glass-card p-8 text-gray-300 leading-relaxed whitespace-pre-wrap"
            data-testid="terms-content"
          >
            {content}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
